import * as React from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {useRecoilState} from "recoil";
import {sidebarState} from "../Recoil/Atom/SideBarAtom";

import NavList from "./NavList";

const drawerStyle = {
  "& .MuiDrawer-paper": {
    position: "absolute",
    top: 64,
  },
};

const NavBar = () => {
  const [isOpen, setIsOpen] = useRecoilState(sidebarState);

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }

    setIsOpen(open);
  };

  return (
    <div>
      <SwipeableDrawer
        sx={drawerStyle}
        open={isOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <NavList />
      </SwipeableDrawer>
    </div>
  );
};

export default NavBar;
